module.exports = __webpack_public_path__ + "img/competition_benefit4.da897cb0.png";